import React from 'react';
import type { OverlayComponentDescription } from './OverlayProvider';

export const OverlayRoot: React.SFC<{ overlays: OverlayComponentDescription[] }> = ({ overlays }) => {
  return overlays.map(overlay => {
    const { render, props } = overlay;
    return <React.Fragment key={props.overlayKey}>{render(props)}</React.Fragment>;
  }) as any;
};
